import { gql } from '@apollo/client';

import DocumentFragment from '../fragments/documentFragment';

export default gql`
  query DocumentsBySubject($courseId: String!, $subjectId: String!) {
    documents(courseId: $courseId, subjectId: $subjectId)
      @rest(
        type: "Document"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/documents"
      ) {
      ...Document
    }
  }
  ${DocumentFragment}
`;
